// extracted by mini-css-extract-plugin
export default {"signature":"doneAs_signature__tTiOo","files":"doneAs_files__41iIY","title":"doneAs_title__uJkgX"};